var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/system/close_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.4144L17.6568 19.0713C18.0473 19.4618 18.6805 19.4618 19.071 19.0713C19.4615 18.6807 19.4615 18.0476 19.071 17.657L13.4142 12.0002L19.071 6.34335C19.4615 5.95283 19.4615 5.31966 19.071 4.92914C18.6805 4.53861 18.0473 4.53861 17.6568 4.92914L12 10.586L6.34309 4.92912C5.95257 4.5386 5.3194 4.5386 4.92888 4.92912C4.53836 5.31965 4.53836 5.95281 4.92888 6.34334L10.5857 12.0002L4.92888 17.6571C4.53836 18.0476 4.53836 18.6807 4.92888 19.0713C5.3194 19.4618 5.95257 19.4618 6.34309 19.0713L12 13.4144Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLine);
export default __webpack_public_path__ + "static/media/close_line.3e79e95ab4a977e929ff29acb595cae2.svg";
export { ForwardRef as ReactComponent };